import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Personal2 = lazy(() =>  retry(()=> import(/* webpackChunkName: "Personal2" */ "./Personal2")));

export default Personal2;